module.exports = __webpack_public_path__ + "fde4d817825e61b48dcd244cca20ff32.svg";